import { useEffect, useRef, useState } from "react";
import { SpecialZoomLevel, Worker, Viewer } from '@react-pdf-viewer/core';
import { toolbarPlugin } from '@react-pdf-viewer/toolbar';
import { fullScreenPlugin } from '@react-pdf-viewer/full-screen';
import './index.scss';

import '@react-pdf-viewer/core/lib/styles/index.css';
import '@react-pdf-viewer/toolbar/lib/styles/index.css';
import '@react-pdf-viewer/full-screen/lib/styles/index.css';
import manager from "../../../Manager";

// if (!window.Worker) {
//     pdfjsLib.disableWorker = true;
// }

function PdfViewer({data}){
    const transactionData = manager.settings?.transactionData ?? {};
    const toolbarPluginInstance = toolbarPlugin();
    const { Toolbar } = toolbarPluginInstance;

    const vierwerRef = useRef(null);
    const [isFullScreen, setIsFullScreen] = useState(false);

    const fullScreenPluginInstance = fullScreenPlugin({
        onEnterFullScreen: (zoom) => {
            zoom(SpecialZoomLevel.PageWidth);
            setIsFullScreen(true);
        },
        onExitFullScreen: (zoom) => {
            zoom(SpecialZoomLevel.PageFit);
            setIsFullScreen(false);
        },
        getFullScreenTarget: () => vierwerRef.current,
    });

    const { EnterFullScreen } = fullScreenPluginInstance;

    const renderPage = (props) => <CustomPageLayer renderPageProps={props} transactionData={transactionData} />;

    return (
        <>
            <div ref={vierwerRef} className={`rpv-core__viewer`}>
                <div className="toolbar">
                    <Toolbar>
                        {(props) => {
                            const { CurrentPageInput, GoToNextPage, GoToPreviousPage, NumberOfPages, Zoom, ZoomIn, ZoomOut } = props;
                            return (
                                <>
                                <div className="toolbar-group">
                                    <GoToPreviousPage />
                                    <CurrentPageInput /> / <NumberOfPages />
                                    <GoToNextPage />
                                </div>
                                <div className="toolbar-group">
                                    <ZoomOut />
                                    <Zoom />
                                    <ZoomIn />
                                </div>
                                <div className="toolbar-group">
                                    <EnterFullScreen />
                                </div>
                                </>
                            );
                        }}
                    </Toolbar>
                </div>
                <div
                    className="content"
                    >
                    {window.structuredClone ?
                    (<Worker workerUrl="https://unpkg.com/pdfjs-dist@3.6.172/build/pdf.worker.min.js">
                        <Viewer
                            fileUrl={data.attachment.fullUrl}
                            renderPage={renderPage} // render custom for disable selected & copy text
                            renderError={() => (
                                <div className="rpv-core__doc-error">
                                    <div className="rpv-core__doc-error-text">Materi tidak tersedia.</div>
                                </div>
                            )}
                            plugins={[
                                toolbarPluginInstance,
                                fullScreenPluginInstance
                            ]}
                        />
                    </Worker>)
                    :
                    (
                        <div className="browser-not-support">
                            <div>
                                <p className="mb-0 text-danger">Your browser not supported to preview pdf</p>
                                <small><i>Please download file if available</i></small>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </>
    )
}

function CustomPageLayer({renderPageProps, transactionData}){
    useEffect(() => {
        if (renderPageProps.canvasLayerRendered) {
            renderPageProps.markRendered(renderPageProps.pageIndex);
        }
    }, [renderPageProps.canvasLayerRendered]);

    return (
        <>
            {renderPageProps.canvasLayer.children}
            { transactionData.externalId && (
                <div
                    style={{
                        alignItems: 'center',
                        display: 'flex',
                        height: '100%',
                        justifyContent: 'center',
                        left: 0,
                        position: 'absolute',
                        top: 0,
                        width: '100%',
                    }}
                >
                    <div
                        style={{
                            color: 'rgba(0, 0, 0, 0.2)',
                            fontSize: `${.45 * renderPageProps.scale}rem`,
                            fontWeight: 'normal',
                            userSelect: 'none',
                            position: 'absolute',
                            left: 0,
                            top: '10px',
                            width: '100%',
                            display:'flex',
                            flexDirection: 'column',
                            textAlign: 'left',
                            padding: '0 10px'
                        }}
                    >
                        <span>Buyer : {transactionData.name || '-'}</span>
                        <span>Transaction ID : {transactionData.externalId || '-'}</span>
                    </div>
                </div>
            )}
            {renderPageProps.annotationLayer.children}
            {/* {renderPageProps.textLayer.children} */}
        </>
    );
}

export default PdfViewer;